<template>
	<el-tooltip v-if="showTooltip" effect="dark" :content="wahlbeteiligungPercentage" placement="top">
		<span class="wahlbeteiligung__label">{{ title }} {{ wahlbeteiligungText }}</span>
	</el-tooltip>
	<span v-else class="wahlbeteiligung__label">{{ title }} {{ wahlbeteiligungText }} = {{ wahlbeteiligungPercentage }}</span>
</template>

<script lang="ts">
import { DecisionState, DecisionType, StatisticDecisionResponseItem } from '@/types/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'Wahlbeteiligung',
	components: {},
	props: {
		decisionsData: {
			type: Object as PropType<StatisticDecisionResponseItem[] | null>,
			required: true,
		},
		title: {
			type: String,
		},
		showTooltip: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			DecisionType,
			noCountedTypes: [DecisionState.Null, DecisionState.UserAbsent] as DecisionState[],
		};
	},
	computed: {
		wahlbeteiligungText() {
			if (!this.decisionsData || this.totalCount === 0) return '';
			return `${this.countedTotal} von ${this.totalCount}`;
		},
		wahlbeteiligungPercentage() {
			if (!this.decisionsData || this.totalCount === 0) return '';
			return `${Number((this.countedTotal / this.totalCount) * 100).toFixed(2)}%`;
		},
		totalCount() {
			if (!this.decisionsData) return 0;
			return this.decisionsData.reduce((acc, decision) => acc + decision.count, 0);
		},
		countedTotal() {
			if (!this.decisionsData) return 0;
			const countedDecisions = this.decisionsData.filter((decision) => !this.noCountedTypes.includes(decision.decisionState));
			return countedDecisions.reduce((acc, decision) => acc + decision.count, 0);
		},
	},
});
</script>
